Postlogin.Admin = Postlogin.Admin || {};
Postlogin.Admin.Assessments = Postlogin.Admin.Assessments || {};
Postlogin.Admin.Assessments.Ccis = Postlogin.Admin.Assessments.Ccis || {};

Postlogin.Admin.Assessments.Ccis.Options = (function () {
    const init = function () {
        $('#ccis-assessment-option-table').on('reorder-row.bs.table', (e, order) => {
            const orderArray = [];
            $.each(order, (index, row) => {
                orderArray.push(row._id);
            });

            $.ajax({
                url: 'save-order/',
                type: 'post',
                data: {
                    order: orderArray,
                },
                success() {},
                error() {},
            });
        });
    };

    return {
        init,
    };
}());
